import Usuario from "model/administracao/cadastro/Usuario";
import HelpdeskChamado from "./HelpdeskChamado";
import { BaseEditModel } from "model/BaseEditModel";
import Arquivo from "model/arquivo/Arquivo";

export default class HelpdeskTramite implements BaseEditModel {

    id: number;
    key: string | null="";
    sequencial: number;
    resposta: string | null;
    data: Date | null;
    usuario: Usuario;
    chamado : HelpdeskChamado;
    arquivos: Arquivo[];

    constructor(
        id = 0,
        sequencial = 0,
        resposta = '',
        data = null,
        usuario = new Usuario(),
        chamado = new HelpdeskChamado,
        arquivos = []
    ) {
       this.id = id;
       this.sequencial = sequencial
       this.resposta = resposta;
       this.data = data;
       this.usuario = usuario;
       this.chamado = chamado;
       this.arquivos = arquivos;
    }
}